import { StoryblokImage } from '@cinch-nx/data-storyblok'
import styles from './image-object.module.css'
export const ImageObject: React.FC<{
  image: StoryblokImage
}> = ({ image }) => (
  <img src={image.filename} alt={image.alt ?? ''} className={styles.image} />
)
